<div
  [class]="!isModal ? 'router-outlet' : 'main-router-outlet'"
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="router.url.includes('teacher-classroom') && isModal"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div *ngIf="!isTeacherCalendar && !classroom" class="d-flex mb-2">
    <div class="pt-3 text-clr">
      <h6 class="quicksand-bold-label calendar-date">Pacing/Lesson Plan</h6>
    </div>
  </div>

  <div *ngIf="isModal && classroom">
    <div class="row" style="margin-top: -1rem">
      <div class="col-md-12 d-flex justify-content-center">
        <nb-card class="classroom-details">
          <nb-card-body>
            <div class="d-flex justify-content-between">
              <div class="classroom-name-content text-left">
                <h5 class="classroom-name quicksand-bold-label">
                  {{ classroom?.name }}
                </h5>

                <div class="classroom-subject quicksand-bold-label">
                  {{ classroom?.subject | uppercase }}
                </div>
              </div>

              <div class="d-flex" style="margin-right: -5px">
                <div class="classroom-code text-center quicksand-normal-label">
                  {{ classroom?.code }}
                </div>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
        <div class="btn-close-content">
          <button class="btn-close" (click)="closeDialog()">
            <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isModal && classroom">
    <label class="card-details-label ml-4"
      >Click on any day to display the “Day View” and to see your lesson plans
    </label>
  </div>

  <div
    [ngClass]="isModal ? (classroom ? 'mt-4 pt-4 m-4 p-3 bg-white expand-view-border' : '') : ''"
    class="main-content date-color"
  >
    <div
      class="d-flex"
      [ngClass]="isModal ? (classroom ? 'justify-content-center' : 'justify-content-between') : 'justify-content-between'"
    >
      <div class="d-flex" [ngClass]="!classroom ? 'navigate-container' : ''">
        <div class="calendar-view-content d-flex">
          <button
            mwlCalendarPreviousView
            [view]="calendarViewType"
            [(viewDate)]="viewDate"
            class="navigate-btn one"
            aria-label="Example icon button with a home icon .name-color"
            (viewDateChange)="closeOpenMonthViewDay()"
            [disabled]="isCalendarStart"
            (click)="navigateCalendar(); calendarService.selectedDate = viewDate"
          >
            <mat-icon class="navigate-icon">navigate_before</mat-icon>
          </button>
          <button
            mwlCalendarToday
            [(viewDate)]="viewDate"
            class="today-btn today-div"
            aria-label="Example icon button with a home icon"
            (click)="navigateCalendar(); calendarService.selectedDate = viewDate"
          >
            Today
          </button>
          <button
            mwlCalendarNextView
            [view]="calendarViewType"
            [(viewDate)]="viewDate"
            class="navigate-btn two"
            aria-label="Example icon button with a home icon"
            [disabled]="isCalendarEnd"
            (click)="navigateCalendar(); calendarService.selectedDate = viewDate"
            (viewDateChange)="closeOpenMonthViewDay()"
          >
            <mat-icon class="navigate-icon">navigate_next</mat-icon>
          </button>
        </div>
        <div class="ml-1">
          <div style="width: 12rem">
            <h6
              *ngIf="calendarViewType"
              class="calendar-date mt-1"
              [ngClass]="!isModal ? 'font-sm-label' : 'font-big'"
            >
              {{ viewDate | calendarDate : calendarViewType + 'ViewTitle' : 'en' }}
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div [ngSwitch]="calendarViewType">
      <ng-container *ngIf="user && user.role_id !== 19">
        <div *ngIf="!isModalView">
          <mwl-calendar-month-view
            class="month-view-calendar month-color"
            *ngSwitchCase="CalendarView.Month"
            [viewDate]="viewDate"
            [events]="events"
            [refresh]="refresh"
            [cellTemplate]="monthViewTemplate"
            (beforeViewRender)="beforeMonthViewRender($event)"
            [ngClass]="!isModal ? 'calendar-sm' : ''"
          >
          </mwl-calendar-month-view>
        </div>

        <div *ngIf="isModalView">
          <div [ngSwitch]="calendarViewType">
            <div
              class="text-center"
              *ngIf="currentCalendar && currentCalendar.length > 0"
            >
              <div *ngIf="!loading">
                <mwl-calendar-month-view
                  [ngClass]="isModal ? 'month-view-calendar' : 'classroom-view-calendar'"
                  *ngSwitchCase="CalendarView.Month"
                  [viewDate]="viewDate"
                  [events]="events"
                  [refresh]="refresh"
                  [cellTemplate]="monthViewTemplate"
                  (beforeViewRender)="beforeMonthViewRender($event)"
                >
                </mwl-calendar-month-view>
              </div>

              <div *ngIf="loading">
                <mwl-calendar-month-view
                  [ngClass]="isModal ? 'month-view-calendar' : 'classroom-view-calendar'"
                  *ngSwitchCase="CalendarView.Month"
                  [viewDate]="viewDate"
                  [events]="events"
                  [refresh]="refresh"
                  [cellTemplate]="monthViewTemplate"
                >
                </mwl-calendar-month-view>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="user && user.role_id === 19">
        <div class="text-center">
          <mwl-calendar-month-view
            [ngClass]="isModal ? 'month-view-calendar' : 'classroom-view-calendar'"
            *ngSwitchCase="CalendarView.Month"
            [viewDate]="viewDate"
            [events]="globalPacingPlanEvents"
            [refresh]="refresh"
            [cellTemplate]="monthViewTemplate"
          >
          </mwl-calendar-month-view>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-template #monthViewTemplate let-day="day" let-locale="locale">
    <div
      (click)="openDayView(day)"
      style="height: 100%; position: relative"
      [nbPopover]="standardsListPopoverTemplate"
      nbPopoverPlacement="right"
      [nbPopoverTrigger]="isModal ? 'hover' : 'noop'"
    >
      <ng-template #standardsListPopoverTemplate let-data>
        <div
          class="standards-list-content"
          [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
          *ngFor="let standard of standardsForTheDay(day.date)"
          [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
        >
          <div
            [ngClass]="
              day?.events[0]?.section_id === 'Test Day' || day?.events[0]?.section_id === 'Review Day' ? 'quicksand-bold-label' : ''
            "
          >
            <div class="quicksand-bold-label section-content">
              {{
                (standard?.global_pacing_plan
                  ? standard?.global_pacing_plan?.section_id
                  : standard?.teacher_custom_pacing_plans?.section_id
                  ? standard?.teacher_custom_pacing_plans?.section_id
                  : standard?.section_id) || '-'
              }}
            </div>
          </div>

          <div class="quicksand-normal-label section-content">
            {{
              (standard?.global_pacing_plan
                ? standard?.global_pacing_plan?.section_title
                : standard?.teacher_custom_pacing_plans?.section_title
                ? standard?.teacher_custom_pacing_plans?.section_title
                : standard?.section_title) || '-'
            }}
          </div>
        </div>
      </ng-template>
      <div
        class="cal-day-number dark-number"
        [ngClass]="isModal ? '' : 'cal-day-number-sm'"
      >
        <span
          *ngIf="day?.isLessonPlan"
          title="Lesson Plan Exists"
          class="contains-lesson-plan"
        ></span>
        {{ day?.date | calendarDate : 'monthViewDayNumber' : locale }}
      </div>
      <br />

      <div
        *ngIf="(classroom && classroom.id) || (isTeacherCalendar && isTeacherCalendar.id)"
        class="bottom-container w-100 text-left"
      >
        <div
          *ngIf="day.events[0]"
          class="cal-events-container"
          [ngClass]="
            day.events[0].cssClass
              ? day.events[0].cssClass
              : (day.events[0].section_id && day.events[0].section_id === 'Test Day') || day.events[0].section_id === 'Review Day'
              ? 'test-review-day'
              : !isModal
              ? 'cal-events-container-sm'
              : ''
          "
        >
          <div
            [ngSwitch]="day.events[0].cssClass"
            class="calendar-main-event-sm font-bold"
          >
            <span
              class="quicksand-bold-label calendar-main-event"
              *ngSwitchCase="'pupil-event'"
            >
              Pupil Free Day</span
            >

            <span
              class="quicksand-bold-label calendar-main-event"
              *ngSwitchCase="'holiday-event'"
              >Holiday</span
            >

            <span
              class="quicksand-bold-label calendar-main-event"
              *ngSwitchCase="'acceleration-event'"
            >
              Acceleration Instructional Day</span
            >

            <span
              class="quicksand-bold-label calendar-main-event"
              *ngSwitchCase="'unassigned-event'"
            >
              Unassigned Day</span
            >
          </div>

          <div *ngIf="!day.events[0].cssClass" class="hover-element">
            <ng-container *ngIf="day.isMultiple === true">
              <div
                [ngClass]="{
                  'mb-2 cal-events': isModal,
                  'cal-event-sm': !isModal
                }"
                *ngFor="let standard of standardsForTheDay(day.date)"
              >
                <span
                  [ngClass]="
                    day.events[0].section_id === 'Test Day' || day.events[0].section_id === 'Review Day' ? 'quicksand-bold-label' : ''
                  "
                >
                  {{
                    (standard?.global_pacing_plan
                      ? standard?.global_pacing_plan?.section_id
                      : standard?.teacher_custom_pacing_plans?.section_id
                      ? standard?.teacher_custom_pacing_plans?.section_id
                      : standard?.section_id) || '-'
                  }}
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="!day.isMultiple">
              <div
                [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
                *ngIf="day.events[0]?.section_id ? day.events[0]?.section_id : '-'"
              >
                <span
                  [ngClass]="
                    day.events[0].section_id === 'Test Day' || day.events[0].section_id === 'Review Day' ? 'quicksand-bold-label' : ''
                  "
                >
                  {{ day.events[0]?.section_id || '-' }}
                </span>
              </div>
            </ng-container>
          </div>

          <!-- <div *ngIf="!day.events[0].cssClass" class="hover-element">
                        <ng-container *ngIf="day.isMultiple === true">
                            <div
                                class="mb-2"
                                [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
                                *ngFor="let standard of standardsForTheDay(day.date)"
                                (mouseenter)="isModal && onHover(true, standard?.section_id, day, standard.id)"
                                (mouseleave)="onHover(false, '', day, standard.id)"
                            >
                                <span
                                    [ngClass]="
                                        day.events[0].section_id === 'Test Day' ||
                                        day.events[0].section_id === 'Review Day'
                                            ? 'font-bold'
                                            : ''
                                    "
                                >
                                    {{ standard?.section_id || '-' }}
                                </span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!day.isMultiple">
                            <div
                                [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
                                *ngIf="day.events[0]?.section_id ? day.events[0]?.section_id : '-'"
                                (mouseenter)="isModal && onHover(true, day.events[0].section_id, day, day.events[0].id)"
                                (mouseleave)="onHover(false, '', day, day.events[0].id)"
                            >
                                <span
                                    [ngClass]="
                                        day.events[0].section_id === 'Test Day' ||
                                        day.events[0].section_id === 'Review Day'
                                            ? 'font-bold'
                                            : ''
                                    "
                                >
                                    {{ day.events[0]?.section_id || '-' }}
                                </span>
                            </div>
                        </ng-container>
                    </div> -->
        </div>
      </div>

      <div *ngIf="!classroom && !isTeacherCalendar">
        <div
          *ngIf="day.events[0]"
          class="cal-events-container w-100"
          [ngClass]="
            day.events[0].cssClass
              ? day.events[0].cssClass
              : (day.events[0].section_id && day.events[0].section_id === 'Test Day') || day.events[0].section_id === 'Review Day'
              ? 'test-review-day'
              : !isModal
              ? 'cal-events-container-sm'
              : ''
          "
        >
          <div
            *ngIf="day.events[0].cssClass"
            class="calendar-main-event font-bold"
          >
            <ng-container *ngIf="day?.events[0]?.cssClass === 'pupil-event'"
              >Pupil Free Day</ng-container
            >
            <ng-container *ngIf="day.events[0].cssClass === 'holiday-event'"
              >Holiday</ng-container
            >
            <ng-container
              *ngIf="day?.events[0]?.cssClass === 'acceleration-event'"
              >Acceleration Instructional Day</ng-container
            >
            <ng-container
              *ngIf="day?.events[0]?.cssClass === 'unassigned-event'"
              >Unassigned Day</ng-container
            >
          </div>

          <div *ngIf="!day.events[0].cssClass">
            <div
              [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
              *ngIf="day.events[0].section_id ? day.events[0].section_id : '-'"
            >
              <span
                [ngClass]="day.events[0].section_id === 'Test Day' || day.events[0].section_id === 'Review Day' ? 'font-bold' : ''"
              >
                {{ day.events[0].section_id ? day.events[0].section_id : '-' }}
              </span>
            </div>
            <div
              [ngClass]="isModal ? 'cal-events' : 'cal-event-sm'"
              *ngIf="day.events[0].section_title"
            >
              {{ day.events[0].section_title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
